import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  createContext
} from 'react';
import deepmerge from 'deepmerge';
import { getFromSession, setFromSession } from 'wtb-utils';

const BillingContext = createContext();

const defaultState = {
  billing: null,
  error: null
};

const BillingProvider = ({ children, initialState: state = {} }) => {
  const initialState = deepmerge(defaultState, state);

  const [ billing, setBilling ] = useState(initialState.billing);
  const [ billingInfoError, setBillingInfoError ] = useState(initialState.error);

  const billingError = JSON.parse(getFromSession('billingInfoError'));

  const isBillingValid = useCallback((_billing) => !!(
    _billing
    && _billing?.firstName
    && _billing?.lastName
    && _billing?.street
    && _billing?.zipCode
    && _billing?.city
    && _billing?.country
    && !billingError
  ), [ billingError ]);

  const hasBillingInfo = useCallback(() => isBillingValid(billing), [ billing, isBillingValid ]);
  useEffect(() => {
    if (!billing) return;
    setFromSession('billing', JSON.stringify(billing));
  }, [ billing, billingInfoError ]);

  useEffect(() => {
    if (!billingInfoError) return;
    setFromSession('billingInfoError', JSON.stringify(billingInfoError));
  }, [ billingInfoError ]);

  return (
    <BillingContext.Provider
      value={{
        billing, setBilling,
        billingInfoError, setBillingInfoError,
        isBillingValid,
        hasBillingInfo
      }}
    >
      {children}
    </BillingContext.Provider>
  );
};

const BillingConsumer = BillingContext.Consumer;

const useBillingContext = () => {
  const context = useContext(BillingContext);

  if (context === undefined) {
    throw new Error('useBillingContext must be used within a BillingProvider');
  }

  return context;
};

export {
  BillingContext, BillingProvider, BillingConsumer, useBillingContext
};
